function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m162.99 194.77 10 20 327-186.73 327 186.73 11-20-338-194.22zm-88 15 3 448v2l-77 44 499 287.46 500-287.46-78-44.09-166 94.09v-148l-84.4 50.21-0.6 138.79-171 107-1.02-446.67zm22 55 81.98 48.39 1.02 84.61-82.98-48.39zm807 0-84.01 48.61-0.99 84.39 85.4-49.1zm-658 86 83.01 48.61 0.99 84.39-84.01-48.61zm425 133 84.4-49.21 0.6-83.79-83.98 48.39zm-574-91 81.98 48.39 1.02 84.61-82.98-48.39zm807 0-84.01 48.61-0.99 84.39 85.4-49.1zm-509 44 83.01 48.53 0.99 85.47-84.01-49.53zm126 134 85.4-51.09 0.6-82.91-85.43 49.38zm-275-92 83.01 48.61 0.99 84.39-83.98-49.21zm425 133 83.98-48.39 1.02-84.61-84.4 49.21zm-574-92 81.98 49.38 1.02 84.62-83.43-49.38zm807 0-84.01 49.53-0.99 84.47 85.4-49.21zm-509 45 83.01 48.53 0.99 83.47-84.43-48.33zm126 133 85.4-50.09 0.6-82.91-85.43 49.38zm-275-92 83.43 50.38 0.57 83.62-83.98-49.21zm149 87 83.4 49.21 0.6 82.79-84.01-47.53zm126 133 85.4-50.09 0.6-82.91-84.98 48.39z",
  stroke: "none"
});

var SvgSituation = function SvgSituation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    fill: "#000",
    width: "264.84mm",
    height: "262.41mm",
    viewBox: "0 0 1000.9727 991.77824",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSituation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/situation.30964f5b.svg";
export { ForwardRef as ReactComponent };